




























































import pipeline from '@/pipeline';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import SendDocumentsPersonal, {
  SendDocumentsPersonalEvent,
} from '@/components/SendDocuments/SendDocumentsPersonal.vue';
import SendDocumentsSponsor, {
  SendDocumentsSponsorEvent,
} from '@/components/SendDocuments/SendDocumentsSponsor.vue';
import BottomButton from '@/components/BottomButton.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import LoadingPage from '@/components/LoadingPage.vue';
import Vue from 'vue';
import { Toast } from '@descomplica/vue-components';
import i18n from '@/i18n';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import IdleMonitor from '@/components/IdleMonitor.vue';

export default Vue.extend({
  components: {
    PipelineMenuWrapper,
    SendDocumentsPersonal,
    BottomButton,
    SendDocumentsSponsor,
    ConfirmationModal,
    LoadingPage,
    Toast,
    IdleMonitor,
  },
  data() {
    return {
      hasUploadedPersonal: false,
      hasUploadedSponsor: false,
      isModalActive: false,
      sponsorDocuments: {},
      personalDocuments: {},
      isLoading: false,
      error: false,
    };
  },
  computed: {
    name(): string {
      return this.$store.getters.studentFirstName || '';
    },
    hasSponsor(): boolean {
      return Boolean(pipeline.state.context.hasFinancialSponsor);
    },
    isFinishEnabled(): boolean {
      const hasAnyDocumentUploaded =
        Object.keys({ ...this.personalDocuments, ...this.sponsorDocuments }).length >= 1;
      return !this.error && hasAnyDocumentUploaded;
    },
    buttonMessage(): string {
      const atLeastOneDocument =
        [...Object.keys(this.personalDocuments), ...Object.keys(this.sponsorDocuments)].length > 0;

      const hasSentAllDocuments =
        this.hasUploadedPersonal && (!this.hasSponsor || this.hasUploadedSponsor);

      if (hasSentAllDocuments) {
        return i18n.t('sendDocuments.buttonWhenHasAllDocuments');
      }
      if (atLeastOneDocument) {
        return i18n.t('sendDocuments.buttonWhenHasAtLeastOneDocument');
      }
      return i18n.t('sendDocuments.buttonWhenLoadPage');
    },
  },
  methods: {
    uploadPersonalHander(event: SendDocumentsPersonalEvent, hasSentAllFiles: boolean) {
      this.personalDocuments = event;
      this.hasUploadedPersonal = hasSentAllFiles;
    },
    uploadSponsorHandler(event: SendDocumentsSponsorEvent, hasSentAllFiles: boolean) {
      this.sponsorDocuments = event;
      this.hasUploadedSponsor = hasSentAllFiles;
    },
    openModal() {
      this.isModalActive = true;
    },
    async finishHandler() {
      if (!this.hasUploadedPersonal || (this.hasSponsor && !this.hasUploadedSponsor)) {
        this.isModalActive = true;
      } else {
        await this.nextPipelineStep();
      }
    },
    async nextPipelineStep() {
      try {
        this.isLoading = true;
        const { personalDocuments, sponsorDocuments } = this;
        await this.$store.dispatch('UPDATE_PERSONAL_DOCUMENTS', { personalDocuments });
        if (this.hasSponsor) {
          await this.$store.dispatch('UPDATE_SPONSOR_DOCUMENTS', { sponsorDocuments });
        }
        await this.nextStep();
      } catch (err) {
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },
    terminateWithError() {
      this.isLoading = true;
      setTimeout(async () => {
        await this.nextStep();
      }, 1000);
    },
    async nextStep() {
      await this.$store.dispatch('UPSERT_ENROLLMENT', { areDocumentsSent: true });
      await this.$store.dispatch(AnalyticsActions.ENROLLMENT_DOCUMENTS_SENT);
      pipeline.next();
    },
    async closeModalHandler(sendNow: boolean) {
      this.isModalActive = false;
      if (!sendNow) {
        await this.nextPipelineStep();
      }
    },
    onidle() {
      if (window && window.bmMaximize) {
        window.bmMaximize();
      }
    },
  },
});
